"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachmentFullFragment = exports.attachmentFragment = void 0;
exports.attachmentFragment = `
  fragment attachment on BosAttachment {
    id
    isSigned
    signingDate
  }
`;
exports.attachmentFullFragment = `
  fragment attachment on BosAttachment {
    contentType
    createdDate
    filename
    isDeleted
    isSigned
    ownerDocumentId
    ownerDocumentType
    signedBy
    signingType
    timestamp
    type
  }
`;
//# sourceMappingURL=attachment.js.map